import PlatformsBox from "../SkillsAndExperience/PlatformsBox";

class Credentials {

    static test_data = {
        sections: [
            {
                name: "platforms",
                title: "Platforms:",
                subsections: [
                    {
                        title: "Mobile",
                        type: "since",
                        items: [
                            {
                                name: "Android",
                                since: 2009,
                            },
                            {
                                name: "Android NDK",
                                since: 2011,
                            },
                            {
                                name: "iOS",
                                since: 2009,
                            },
                            {
                                name: "Xamarin Native/Forms",
                                since: 2014,
                            },
                            {
                                name: "Windows Phone/Mobil/CE",
                                since: 1998,
                            },
                            {
                                name: "Palm OS",
                                since: 1998,
                            },
                        ],
                    },
                ],
            },
        ],
    }

    static data = {
        sections: [
            {
                name: "platforms",
                title: "Platforms:",
                subsections: [
                    {
                        title: "Mobile",
                        type: "since",
                        items: [
                            {
                                name: "Android",
                                since: 2009,
                            },
                            {
                                name: "Android NDK",
                                since: 2011,
                            },
                            {
                                name: "iOS",
                                since: 2009,
                            },
                            {
                                name: "Flutter",
                                since: 2024,
                            },
                        ],
                    },
                    {
                        title: "Server",
                        type: "since",
                        items: [
                            {
                                name: "Unix/Linux",
                                since: 1977,
                            },
                            {
                                name: "Golang",
                                since: 2018,
                            },
                            {
                                name: "Node.JS",
                                since: 2016,
                            },
                            {
                                name: "NGINX",
                                since: 2016,
                            },
                            {
                                name: "MS Windows NT/Server",
                                since: 1993,
                            },
                            {
                                name: "Amazon Web Services",
                                since: 2015,
                            },
                        ],
                    },
                    {
                        title: "Web",
                        type: "since",
                        items: [
                            {
                                name: "Node.js",
                                since: 2016,
                            },
                            {
                                name: "ReactJS",
                                since: 2016,
                            },
                            {
                                name: "Flutter",
                                since: 2024,
                            },
                            {
                                name: "Amazon Web Services",
                                since: 2015,
                            },
                        ],
                    },
                    {
                        title: "Desktop",
                        type: "since",
                        items: [
                            {
                                name: "Linux",
                                since: 1999,
                            },
                            {
                                name: "Windows",
                                since: 1985,
                            },
                            {
                                name: "macOS / OS X",
                                since: 1999,
                            },
                        ],
                    },
                    {
                        title: "Embedded and IoT",
                        type: "since",
                        items: [
                            {
                                name: "Embedded Linux",
                                since: 2005,
                            },
                            {
                                name: "FreeRTOS",
                                since: 2011,
                            },
                            {
                                name: "Microchip PIC uControllers",
                                since: 1995,
                            },
                            {
                                name: "ARM uControllers",
                                since: 2013,
                            },
                            {
                                name: "SBC / Arduino / Raspberry Pi",
                                since: 1993,
                            },
                        ],
                    },
                ],
            },
            {
                name: "langtech",
                title: "Languages and Technologies:",
                subsections: [
                    {
                        title: "Languages:",
                        type: "since",
                        items: [
                            {
                                name: "Kotlin",
                                since: 2017,
                            },
                            {
                                name: "Java",
                                since: 1997,
                            },
                            {
                                name: "Go/Golang",
                                since: 2018,
                            },
                            {
                                name: "C",
                                since: 1977,
                            },
                            {
                                name: "C++",
                                since: 1992,
                            },
                            {
                                name: "C# and .NET",
                                since: 2004,
                            },
                            {
                                name: "JavaScript",
                                since: 1997,
                            },
                            {
                                name: "Dart",
                                since: 2024,
                            },
                            {
                                name: "Swift",
                                since: 2016,
                            },
                            {
                                name: "PHP",
                                since: 1999,
                            },
                            {
                                name: "Assembler",
                                since: 1977,
                            },
                            {
                                name: "SQL",
                                since: 2000,
                            },
                            {
                                name: "BASIC",
                                since: 1978,
                            },
                        ],
                    },
                    {
                        title: "Other Technologies:",
                        type: "groupedlist",
                        groups: [
                            {
                                name: "Databases:",
                                items: [
                                    { name: "PostgreSQL"},
                                    { name: "MySQL"},
                                    { name: "SQLite"},
                                    { name: "MS SQL Server"},
                                    { name: "Oracle"},
                                    { name: "Mongo"},
                                ],
                            },
                            {
                                name: "Networking:",
                                items: [
                                    { name: "Sockets"},
                                    { name: "TCP/IP"},
                                ],
                            },
                            {
                                name: "Wired:",
                                items: [
                                    { name: "Ethernet"},
                                    { name: "RS-232/422/485"},
                                    { name: "SPI"},
                                    { name: "I2C"},
                                    { name: "CAN"},
                                    { name: "Lin"},
                                    { name: "OBD-II"},
                                ],
                            },
                            {
                                name: "Wireless:",
                                items: [
                                    { name: "WiFi"},
                                    { name: "Bluetooth/BLE"},
                                    { name: "Zigbee"},
                                    { name: "LoRa"},
                                    { name: "Digimesh"},
                                    { name: "Embedded Cellular"},
                                    { name: "Embedded WiFi"},
                                    { name: "Embedded Cellular"},
                                ],
                            },
                            {
                                name: "Misc:",
                                items: [
                                    { name: "Concurrency/Multi-Threading"},
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                name: "industries",
                title: "Industries I have contracted in:",
                subsections: [
                    {
                        title: "",
                        type: "groupedlist",
                        groups: [
                            {
                                name: "Consumer:",
                                items: [
                                    { name: "eCommerce"},
                                    { name: "Real Estate"},
                                    { name: "Food/Restaurant"},
                                    { name: "Point of Sale"},
                                    { name: "Entertainment"},
                                    { name: "Health & Fitness"},
                                ],
                            },
                            {
                                name: "Transportation:",
                                items: [
                                    { name: "Aerospace"},
                                    { name: "Marine"},
                                    { name: "Railroad"},
                                    { name: "Trucking"},
                                    { name: "Navigation"},
                                    { name: "Fleet Tracking"},
                                    { name: "Fleet Management"},
                                ],
                            },
                            {
                                name: "Industrial:",
                                items: [
                                    { name: "Mining"},
                                    { name: "Manufacturing Management"},
                                    { name: "Manufacturing Control"},
                                    { name: "Research and Development"},
                                    { name: "Manufacturing Control"},
                                ],
                            },
                            {
                                name: "Finance:",
                                items: [
                                    { name: "Insurance"},
                                    { name: "Securities"},
                                    { name: "Derivatives"},
                                    { name: "Portfolio Management"},
                                    { name: "Trading"},
                                    { name: "Financial Engineering"},
                                ],
                            },
                            {
                                name: "Medicine:",
                                items: [
                                    { name: "Medical Devices"},
                                    { name: "Device Integration"},
                                    { name: "Medical Imaging"},
                                    { name: "Health and Fitness"},
                                ],
                            },
                            {
                                name: "Government:",
                                items: [
                                    { name: "Defense"},
                                    { name: "Homeland Security"},
                                    { name: "Robotics"},
                                ],
                            },
                            {
                                name: "Other:",
                                items: [
                                    { name: "Scientific"},
                                    { name: "Engineering"},
                                    { name: "Academics"},
                                ],
                            },
                        ],
                    },
                ],
            },
            {
                name: "clients",
                title: "Partial List of Clients:",
                subsections: [
                    {
                        title: "",
                        type: "list",
                        items: [
                            {
                                name: "Boeing",
                                url: "",
                            },
                            {
                                name: "NASA",
                                url: "",
                            },
                            {
                                name: "Sandia National Lab",
                                url: "",
                            },
                            {
                                name: "Los Alamos National Lab",
                                url: "",
                            },
                            {
                                name: "IBM",
                                url: "",
                            },
                            {
                                name: "Goodyear Tire & Rubber",
                                url: "",
                            },
                            {
                                name: "Charles Schwab",
                                url: "",
                            },
                            {
                                name: "Thermo Fisher Scientific",
                                url: "",
                            },
                            {
                                name: "Altec Lansing",
                                url: "",
                            },
                            {
                                name: "Skyhook Wireless",
                                url: "",
                            },
                            {
                                name: "SAP/Sybase",
                                url: "",
                            },
                            {
                                name: "Century 21/ERA Real Estate",
                                url: "",
                            },
                        ],
                    },
                ],
            },
        ],
    }
}

export default Credentials



// WEBPACK FOOTER //
// src/ResumeAndDocs/credentials.js